export const locales = [
  "cs-CZ",
  "da-DK",
  "de-AT",
  "de-CH",
  "de-DE",
  "en-AU",
  "en-GB",
  "en-IE",
  "en-NZ",
  "en-US",
  "es-ES",
  "et-EE",
  "fi-FI",
  "fr-BE",
  "fr-CH",
  "fr-FR",
  "it-CH",
  "it-IT",
  "nb-NO",
  "nl-BE",
  "nl-NL",
  "pl-PL",
  "sv-SE",
] as const

export type Locale = (typeof locales)[number]

export const isLocale = (locale: string): locale is Locale => {
  return locales.includes(locale as Locale)
}

const streetNrCountries = ["DE", "AT", "BE", "NL"]

export const streetNrRequired = (forCountry: string): boolean => {
  return streetNrCountries.includes(forCountry.toUpperCase())
}

export const showStreet2 = (country: string): boolean => {
  return ["GB", "IE", "FR", "US", "EE", "ES", "FI"].includes(country)
}

export const stateRequired = (country: string): boolean => {
  return ["AU", "US"].includes(country)
}

export const multilingual = (urlLocale: string) => {
  return urlLocale.includes("BE") || urlLocale.includes("CH")
}

export const url = (path: string, urlLocale: string) => {
  if (multilingual(urlLocale)) {
    return `/${urlLocale.substr(0, 2)}${path}`
  }

  return path
}

export default locales
